import React from "react";
import styles from "../Header.css";
import { isSMKGuide } from "../../../services/service-utils";

export default function MenuSection({
  currentRoute,
  headerProps,
  activeMenuIndex,
  setActiveMenuIndex,
}) {
  const { menuOpen, searchOpen } = headerProps;
  const { menu, opening_hours, hide_opening_hours } = currentRoute;

  const isActiveItem = (idx, url) => {
    if (document.location.pathname === url) return true;
    if (activeMenuIndex === idx) return true;
  };

  return (
    <div
      className={styles.MenuSection}
      style={{
        justifyContent:
          menuOpen || hide_opening_hours || isSMKGuide(currentRoute)
            ? "flex-end"
            : "space-between",
      }}
    >
      {opening_hours && (
        <div className={styles.MenuLinks}>
          {menu.map((item, idx) => (
            <a
              href={item.url}
              onClick={(e) => {
                setActiveMenuIndex(e, idx, item);
              }}
              key={idx}
              className={[
                styles["MenuLinks-Item"],
                isActiveItem(idx, item.url)
                  ? styles["MenuLinks-Item_active"]
                  : "",
              ].join(" ")}
            >
              {item.title}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Header/Components/MenuSection.js